<div class="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
  @for (list of lists; track list.role) {
    <div class="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03]">
      <h3 class="text-base font-semibold text-gray-800 dark:text-white/90">{{ list.label }}</h3>
      <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{ list.helper }}</p>

      <div class="mt-4 flex gap-2">
        <input
          type="text"
          [(ngModel)]="list.newName"
          (keyup.enter)="add(list)"
          placeholder="Add a name"
          class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-3.5 text-sm text-gray-800 focus:border-brand-300 focus:outline-hidden dark:border-gray-700 dark:text-white/90"
        />
        <button
          type="button"
          (click)="add(list)"
          [disabled]="!list.newName.trim() || list.saving"
          class="shadow-theme-xs inline-flex h-11 items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03]">
          <lucide-icon [name]="PlusIcon" class="h-4 w-4"></lucide-icon>
          Add
        </button>
      </div>

      <ul class="mt-4 divide-y divide-gray-100 dark:divide-gray-800">
        @for (entry of list.entries; track entry.id) {
          <li class="flex items-center justify-between gap-3 py-2.5">
            @if (editingId === entry.id) {
              <input
                type="text"
                [(ngModel)]="editingName"
                (keyup.enter)="saveEdit(list, entry)"
                class="h-9 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 focus:border-brand-300 focus:outline-hidden dark:border-gray-700 dark:text-white/90"
              />
              <div class="flex items-center gap-2">
                <button type="button" (click)="saveEdit(list, entry)" class="text-green-500 hover:text-green-700">
                  <lucide-icon [name]="CheckIcon" class="h-4 w-4"></lucide-icon>
                </button>
                <button type="button" (click)="cancelEdit()" class="text-gray-400 hover:text-gray-600">
                  <lucide-icon [name]="CancelIcon" class="h-4 w-4"></lucide-icon>
                </button>
              </div>
            } @else {
              <span
                class="text-sm"
                [class]="entry.is_active ? 'text-gray-800 dark:text-white/90' : 'text-gray-400 line-through'">
                {{ entry.name }}
                @if (!entry.is_active) {
                  <span class="ml-1 text-xs">(inactive)</span>
                }
              </span>
              <div class="flex items-center gap-3">
                <button type="button" (click)="startEdit(entry)" class="text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400">
                  Rename
                </button>
                @if (entry.is_active) {
                  <button type="button" (click)="toggleActive(list, entry)" class="text-red-500 hover:text-red-700" title="Deactivate">
                    <lucide-icon [name]="ArchiveIcon" class="h-4 w-4"></lucide-icon>
                  </button>
                } @else {
                  <button type="button" (click)="toggleActive(list, entry)" class="text-green-500 hover:text-green-700" title="Reactivate">
                    <lucide-icon [name]="RestoreIcon" class="h-4 w-4"></lucide-icon>
                  </button>
                }
              </div>
            }
          </li>
        } @empty {
          <li class="py-2.5 text-sm text-gray-400">No names yet.</li>
        }
      </ul>
    </div>
  }
</div>
